// extracted by mini-css-extract-plugin
export default {"mobileMax":"599.98px","desktopMin":"600px"};